export enum EditorEvent {
  OPEN_EDITOR = 'contract editor - open',
  SAVE_IN_EDITOR = 'contract editor - save',
  CANCEL_EDITION = 'contract editor - cancel',
  DOWNLOAD_IN_EDITOR = 'contract editor - download',
  GO_SIGNING = 'contract sign tool - open',
  DOWNLOAD_SIGNING_LOG = 'contract sign tool - download signing log'
}
